module.exports = __webpack_public_path__ + "img/prize3_active.61e2a6b.png";